/* PreventivassMeter.jsx — barra completezza dati per Preventivass */
import { Sparkles } from "lucide-react";

export default function PreventivassMeter({ percent, label }) {
  const p = Math.max(0, Math.min(100, percent || 0));
  const color = p < 40 ? "bg-amber-500" : p < 70 ? "bg-sky-500" : "bg-emerald-500";
  return (
    <div
      data-testid="preventivass-meter"
      className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
    >
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-2 text-sm font-medium text-[#163321]">
          <Sparkles className="w-4 h-4 text-amber-500" />
          Completezza dati
        </div>
        <span
          data-testid="preventivass-meter-value"
          className="text-sm font-bold text-[#163321]"
        >
          {p}%
        </span>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
        <div
          className={`h-full ${color} transition-all duration-500`}
          style={{ width: `${p}%` }}
        />
      </div>
      <p className="text-xs text-slate-500 mt-2">
        {label || (
          p < 40 ? "Continua: più dati = preventivo più preciso." :
          p < 70 ? "Buon livello. Completa tutto per il miglior preventivo." :
          "Pronto per il miglior preventivo!"
        )}
      </p>
    </div>
  );
}
